export const getPdfSingFeild = (createmode, signInputfield) => {
  if (createmode === 'false' && window.location.pathname !== '/templatepreview') {
    const allcontainers = document.querySelectorAll('.pdf-sign');

    [...allcontainers].forEach(el => {
      signInputfield.forEach(item => {
        const checkElm = document.querySelector('#signinput' + item.inputId);
        const currentDate = new Date().toLocaleDateString();
        if (checkElm) {
          checkElm.innerHTML = `Signed by : ${item.value} - ${currentDate}`;
          return '';
        }

        const createInputTag = document.createElement('span');

        createInputTag.innerHTML = `Signed by : ${item.value} - ${currentDate}`;
        createInputTag.style.display = 'block';
        createInputTag.style.fontSize = '12px';
        createInputTag.setAttribute('id', 'signinput' + item.inputId);
      });
    });
  }
};

export const getSignFields = (createmode, singedFields) => {
  if (createmode === 'false') {
    const getEsignInputsfromPage = document.querySelectorAll('.template-esign');

    singedFields.forEach(item => {
      [...getEsignInputsfromPage].forEach(element => {
        if (element.getAttribute('id') === item.inputId) {
          element.setAttribute('value', item?.value);
          element.setAttribute('data-recp', item?.id);
          element.style.width = `${item?.value?.length * 11}px`;
        } else {
          element.setAttribute('name', element.getAttribute('name'));
        }
      });
    });
  }
};
export const fillRecipientsInput = (createmode, filledRecipients) => {
  console.log("filledRecipients",filledRecipients)
  if (createmode === 'false') {
    const getRecipientInputsfromPage = document.querySelectorAll('.template-recipient');

    filledRecipients.forEach(item => {
      
      [...getRecipientInputsfromPage].forEach(element => {
        if(element){
            // console.log("fillRecipients item", item)
           // console.log("fillRecipients element", element)
          if (element.getAttribute('name') === item?.name) {
            element.setAttribute('value', item?.inval);
            // element.style.width = `${item?.inval?.length * 12}px`;
          }else if(element.getAttribute('id') === item?.inputId){
            element.setAttribute('value', "");
          }
        }
      });
    });
  }
};
